import { Card } from 'antd';
import { State } from 'constants/site';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Header from './components/Header';
import Table from './components/Table';

const List = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const showActive = pathname.includes(State[State.ACTIVE].toLowerCase());

  return (
    <>
      <Helmet title={`Kvalilog > ${t('pages.sites.title')}`} />
      <Card bordered={false} title={<Header />}>
        <Table showActive={showActive} />
      </Card>
    </>
  );
};

export default List;
